export default "__VITE_ASSET__SwTSmbtg__"